<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-60">
           <div class="flc mt-60">
                <div class="middle_contact">
                   <img :src="contact.image" alt="">
                </div>
                <div class="contact">
                    <div class="flc mb-20">
                        <div class="contact_box fdc">
                            <img  src="@/assets/images/iconfont_2.png" alt="">
                            <span class="contact_tal ml-20">地址:</span>
                        </div>
                        <div class="contact_text">{{contact.address}}</div>
                    </div>
                    <div class="flc mb-20">
                        <div class="contact_box fdc">
                            <img  src="@/assets/images/iconfont_1.png" alt="">
                            <span class="contact_tals ml-20">邮箱:</span>
                        </div>
                        <div class="contact_text">{{contact.email}}</div>
                    </div>
                    <div class="flc">
                        <div class="contact_box fdc">
                            <img  src="@/assets/images/iconfont_3.png" alt="">
                            <span class="contact_tal ml-20">电话:</span>
                        </div>
                        <div class="contact_wer">
                          <!--  <p class="contact_text">86-10-61351199</p> -->
                            <p class="contact_text ml-10">{{contact.telephone}}</p>
                            <!-- <p class="contact_text ml-10">86-10-61351156(销售)</p> -->
                        </div>
                    </div>
                </div>
           </div>
        </div>

    </div>
</template>
<script>
import {linkus} from '@/api/coment'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
export default {
    components:{commBanner,titleHead},
    data(){
        return{
            headTitle:'联系我们',
            obj:{
                title:'联系我们',
                contCount:'',
                isShow:true,
                roleType:'',
                personalType:'',
                companytype:''
            },
			contact:{}
        }
    },
	created(){
       this.getList();
       this.getMate();
       if(this.$store.state.user.userInfo != null){
         this.obj.roleType = this.$store.state.user.userInfo.type;
         this.obj.personalType = 9;
       }
	},
    methods:{
	   //列表
	   getList(){
		  linkus({
			curPage:1,
			limit:10
		  }).then((res)=>{
			 if(res.code == 0){
			   this.contact = res.data.list[0];
			 }
		  }).catch((err)=>{})
       },
       getMate(){
        var metas = document.getElementsByTagName("meta"); 
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
       },
    }
}
</script>
<style scoped>
@import url('../../assets/css/coment.css');
.flc{
    display: flex;
    justify-content: left;
    align-items: center;
}
.mr-60{
    margin-right: 60px;
}
.ml-10{
    margin-left: 10px;
}
.ml-15{
    margin-left: 15px;
}

.ml-20{
    margin-left: 20px;
}
.mt-60{
  margin-top: 60px;
}
.mb-60{
    margin-bottom: 60px;
}
.mb-20{
    margin-bottom: 20px;
}
.middle_contact{
    width: 45%;
    overflow: hidden;
}
.middle_contact img{
    width: 100%;
    height: 322px;
    transition: all 0.5s;
}
.middle_contact img:hover{
    transform: scale(1.2);
}
.contact{
    width: 55%;
    padding-left: 30px;
}
.contact img{
    width: 26px;
    height: 25px;
}
.icon_1{
  width: 20px;
  height: 25px;
}
.icon_2{
  width: 24px;
  height: 18px;
}
.icon_3{
   width: 25px;
   height: 25px;
}
.contact_tal{
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.contact_text{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 15px;
}

</style>



// WEBPACK FOOTER //
// src/view/other/contact_us.vue